/* eslint-disable jsx-a11y/anchor-is-valid */
import FlagIcon from 'Assets/images/commons/flag.svg';
import PersonAvatar from 'Containers/Teleconsult/Sidebar/List/ChatListGroup/PersonAvatar';
import { calculateYearsOld } from 'Helpers/consult-utils';
import { func, shape } from 'prop-types';
import React from 'react';
import { Image } from 'semantic-ui-react';

import styles from './PatientInfo.less';

const PatientInfo = ({
  parentPatient,
  patient: { fullName, genderAtBirth, dateOfBirth, tags },
  goToPatient,
}) => {
  return (
    <div className="patient">
      <PersonAvatar data={parentPatient} />
      <div className="info">
        <a className="name" onClick={goToPatient}>
          {fullName}
        </a>
        <div className="detail">
          <span>{genderAtBirth}</span>
          {dateOfBirth && (
            <span>{`${genderAtBirth ? ', ' : ''}${calculateYearsOld(dateOfBirth)}`}</span>
          )}
        </div>
      </div>
      {tags?.length > 0 && (
        <div className={styles.tags}>
          <Image src={FlagIcon} />
          {tags?.map(tag => (
            <div className={styles.tag} key={tag.id}>
              {tag.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

PatientInfo.propTypes = {
  patient: shape({}).isRequired,
  parentPatient: shape({}).isRequired,
  goToPatient: func.isRequired,
};

export default PatientInfo;
